module.exports = __webpack_public_path__ + "static/img/order-no-01.7661bca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/order-no-01.jpg
// module id = 281
// module chunks = 1